import { render, staticRenderFns } from "./transferQuery.vue?vue&type=template&id=05918eaa&scoped=true&"
import script from "./transferQuery.vue?vue&type=script&lang=js&"
export * from "./transferQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05918eaa",
  null
  
)

export default component.exports